var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 100,
    viewBox: "0 0 86 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.9378 2.09228C40.7363 -0.697428 45.2811 -0.697428 48.0796 2.09228L83.9005 37.8006C85.9602 39.8538 86.5647 42.9113 85.4453 45.5895C84.3259 48.2676 81.7289 50.0084 78.8184 50.0084H57.3259V91.0729C57.3259 96.0051 53.3184 100 48.3707 100H37.6244C32.6766 100 28.6692 96.0051 28.6692 91.0729V50.0084H7.17664C4.28858 50.0084 1.66918 48.2676 0.549777 45.5895C-0.569626 42.9113 0.0572394 39.8538 2.09455 37.8006L37.9154 2.09228H37.9378Z",
    fill: "#3A6035"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/upArrow.f3dee13a1de8ad14c03e70b01536592d.svg";
export { ForwardRef as ReactComponent };